/**
 * Khớp KNOWN_SITE_DOMAINS bên API (phimmoihd_api/src/common/site-domain.const.ts)
 * — thêm domain mới thì sửa cả 2 chỗ, chưa có API trả danh sách domain động.
 *
 * Dùng chung cho mọi field domains[] trong admin (bài viết, banner, textlink...)
 * thay vì mỗi trang tự khai một danh sách riêng — từng bị lệch (EditArticlePage
 * thiếu phimmoihd.shop/store khi 2 site đó ra đời) vì không có 1 nguồn duy nhất.
 */
export const SITE_DOMAINS = [
  { label: "phimmoihd.it.com", value: "phimmoihd.it.com" },
  { label: "phimmoihd.online", value: "phimmoihd.online" },
  { label: "phimmoihd.shop", value: "phimmoihd.shop" },
  { label: "phimmoihd.store", value: "phimmoihd.store" },
];
